import { Close } from '@mui/icons-material';
import { Box, DialogTitle, Grid, IconButton } from '@mui/material';
import MaterialTable from '../material-table/material-table';
import Modal from '../modal/modal';
import Typography from '../typography/typography';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';
import ModalLoader from '../loaders/modal-loader';
import { responseItemDetailsColumns } from '../../utils/constant';
import {
	fetchRentalResponseItems,
	fetchRfqItemsByIdForResponse,
	getErrorMessage
} from '../../utils/common';
import { transformTableColumns } from '../../utils/common-utility';
export const ItemResponseDetails = (props: any) => {
	const { isOpen, onClose, data, isRental = false } = props;
	const [responseItems, setResponseItems] = useState<any[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const { t } = useTranslation();

	const getResponseItems = useCallback(async () => {
		if (!isOpen) return;
		try {
			setIsLoading(true);
			const filters = `(rfq_line_item_id.in=${[data?.id]})`;
			const rfqResponseItems = isRental
				? await fetchRentalResponseItems(filters)
				: await fetchRfqItemsByIdForResponse(filters);
			setResponseItems(rfqResponseItems);
		} catch (error) {
			const errorMsg = getErrorMessage(error?.message);
			enqueueSnackbar(errorMsg, { variant: 'error' });
		} finally {
			setTimeout(() => setIsLoading(false), 300);
		}
	}, [isOpen, data?.id, isRental]);
	useEffect(() => {
		getResponseItems();
	}, [getResponseItems]);
	return (
		<Modal open={isOpen} onClose={onClose} maxWidth='md' fullWidth>
			{isLoading && <ModalLoader />}
			<DialogTitle className='itemEntryModal--DialogTitle'>
				<Typography type='s3' color='inherit' weight='medium'>
					Response Details
				</Typography>
				<IconButton onClick={onClose}>
					<Close fontSize='small' />
				</IconButton>
			</DialogTitle>
			<Grid container>
				<Grid item xs={4}>
					<Box sx={{ display: 'flex', padding: 2, flexDirection: 'column' }}>
						<Typography type='s5' weight='medium' color='theme.secondary.800'>
							Item
						</Typography>
						<Typography type='s3' weight='medium' color='theme.neutral.1000'>
							{data?.item_data?.name}
						</Typography>
					</Box>
				</Grid>
			</Grid>

			<Grid container p={2} spacing={3}>
				<Grid item xs={12}>
					<Box sx={{ paddingTop: '1.2rem' }}>
						<MaterialTable
							rows={responseItems || []}
							columns={transformTableColumns({
								columns: responseItemDetailsColumns,
								currencySymbol: undefined,
								translationFn: t,
								customizeValue: (row, columnAccessorKey, value) => {
									switch (columnAccessorKey) {
										case 'item_data.vendor_info.vendor_name':
											return value || row?.original?.item_data?.name;
									}
								}
							})}
							paginationModel={{ pageNo: 1, limit: 20 }}
							totalPages={20}
							enableColumnDragging={true}
							isResetRow={false}
							enableEditing={false}
							columnOrder={['mrt-row-select']}
							enableRowSelection={false}
							disabledDefaultActionColumnIcon
							enableBottomToolbar={false}
						/>
					</Box>
				</Grid>
			</Grid>
		</Modal>
	);
};

export default ItemResponseDetails;
